import { ChangeEvent } from 'react';

import styles from './toggle.module.scss';

interface IToggleProps {
  isEnable: boolean;
  id: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  testId?: string;
  disabled?: boolean;
}

export default function Toggle({ isEnable, onChange, id, testId, disabled }: IToggleProps) {
  return (
    <label
      className={styles.toggle}
      htmlFor={id}
    >
      <input
        id={id}
        type="checkbox"
        checked={isEnable}
        disabled={disabled}
        onChange={onChange}
        className={styles['input-checkbox']}
        data-testid={testId}
      />
      <span className={styles['custom-checkbox']} />
    </label>
  );
}
